import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { Macro } from "@redotech/redo-support-common/macro";

/**
 * GET /team/macros
 */
export async function getMacros(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal },
): Promise<{ data: Macro[] }> {
  const response = await client.client.get("team/macros", {
    headers: client.authorization(),
    signal,
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const data = (response.data as Macro[]).sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  return { data };
}
